export default function getUTCNoonForDate (input) {
  try {
    if (input) {
      return input.clone().utc(true).startOf('day').hour(12).valueOf();
    }
  } catch (e) {
    return null;
  }
  return null;
}
